"use client";

import {
  CampaignCard,
  BlogCard,
  BrandCard,
  BenefitCard,
} from "@/components/featured/common";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";
import RouteCard from "@/components/pages/ferry/cards/RouteCard";
import IconTextCard from "@/components/pages/ferry/cards/IconTextCard";
import FaqAccordion from "@/components/FaqAccordion";

export const componentRegistry = {
  OpportunitiesCardWrapper,
  CampaignCard,
  BlogCard,
  RouteCard,
  IconText: IconTextCard,
  BrandCard,
  BenefitCard,
  FaqAccordion,
};

export const itemPropMapping = {
  OpportunitiesCardWrapper: "item",
  CampaignCard: "item",
  BlogCard: "post",
  RouteCard: "item",
  IconText: "item",
  BrandCard: "brand",
  BenefitCard: "item",
  FaqAccordion: "item",
};
